
import { KYMW6801Model } from '../kymw6801.model';
import { KYMW6800commonModel } from '../../kymw6800/vo/kymw6800-common.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * CWSカテゴリ変換マスタ情報を削除する
 *
 * @export API通信成功時の処理
 * @class DeleteCategoryConvInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteCategoryConvInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6801Model;
  private successFunc: Function;
  private vo: KYMW6800commonModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCategoryConvInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryConvId: this.vo.categoryConvID,
        UpdateDate: this.vo.updateDate,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6801Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof DeleteCategoryConvInfoService
   */
  execute(model: KYMW6801Model, vo: KYMW6800commonModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteCategoryConvInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteCategoryConvInfoService
   */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
